/**
 * Manager bot intents.
 * - QUICK_ACTIONS: chips under the chat.
 * - REPORT_OPTIONS: list shown after "Report" is chosen. Add new reports here.
 * - matchIntent(): free-text → action. "z out report", "Z - Out Report",
 *   "zout" all resolve to the same action.
 */
export const QUICK_ACTIONS = [
  { label: "Hotel details", action: "ADMIN_HOTEL_DETAILS" },
  { label: "Reservation", action: "ADMIN_RESERVATION" },
  { label: "Report", action: "ADMIN_REPORT_MENU" },
];

export const REPORT_OPTIONS = [
  { label: "Z - Out Report", action: "ADMIN_ZOUT_REPORT" },
  { label: "Revenue By Source", action: "ADMIN_REVENUE_BY_SOURCE" },
  { label: "Transaction Batch", action: "ADMIN_TRANSACTION_BATCH" },
  { label: "OTA Commission", action: "ADMIN_OTA_COMMISSION" },
];

// Order matters: most specific first.
const TYPED_RULES = [
  { test: (k) => k.includes("zout"), action: "ADMIN_ZOUT_REPORT" },
  { test: (k) => k.includes("revenue") && k.includes("source"), action: "ADMIN_REVENUE_BY_SOURCE" },
  { test: (k) => k.includes("transaction") || k.includes("batch"), action: "ADMIN_TRANSACTION_BATCH" },
  { test: (k) => k.includes("commission") || k.includes("ota"), action: "ADMIN_OTA_COMMISSION" },
  { test: (k) => k.includes("report"), action: "ADMIN_REPORT_MENU" },
  { test: (k) => k.includes("reservation") || k.includes("booking"), action: "ADMIN_RESERVATION" },
  { test: (k) => k.includes("hotel"), action: "ADMIN_HOTEL_DETAILS" },
];

export function matchIntent(text = "") {
  // "Z - Out Report" / "z out report" / "Z-OUT" → "zoutreport"
  const key = text.toLowerCase().replace(/[^a-z0-9]/g, "");
  return TYPED_RULES.find((r) => r.test(key))?.action ?? null;
}